import React from 'react';
import ReactDOM from 'react-dom/client';
import "milligram";
import App from './App';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import reportWebVitals from './reportWebVitals';
import Login from './login/login'
import Dashboard from './dashboard/dashboard';
import UserList from './user/user.js';
import Programs from './user/programs.js';
import Menu from './user/menu.js';
import Doctor from './doctor/doctor.js';
import Appointment from './appointments/appointment.js';
import Staff from './staff/staff.js';
import AddStaff from './staff/addstaff.js';
import Editstaff from './staff/editstaff.js';
import Addappointments from './appointments/addappoint.js';
import EditAppoint from './appointments/editappoint.js';
import DashboardElement from './dashboard/dashboardElement.js';
import "./index.css";
import Hospital from './hospital/hospital.js';
import AddHospitals from './hospital/addhosp.js';
import EditHospitals from './hospital/edithosp.js';
import AdminLiveTracking from './livetrack/livetrack.js';
import PolygonMap from './area/area.js'
import Arealist from './area/arealist.js'
import Clinics from './clinics/clinics.js'
import AddClinic from './clinics/addclinic.js'
import EditClinic from './clinics/editclinic.js'
import AddRegion from './area/region.js'
import SessionTrack from './livetrack/sessiontrack';
import SessionReport from './livetrack/sessionreport';
import DoctorBulkAssign from './doctorassignment/doctorbulkassign.js';
import BillingReport from './billing/billingreport.js';
import AppointmentReport from './reports/AppointmentReport';
import { installAuthGuard } from './authservice/authguard';
import DoctorAssignment from './doctorassignment/doctorassignment.js';

installAuthGuard();

const resizeObserverErr = window.ResizeObserver;
window.ResizeObserver = class extends resizeObserverErr {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));



root.render(
  <React.StrictMode>
    {/* <BrowserRouter> */}
    <BrowserRouter basename="/ddcMarketing">
      <Routes>
        <Route index element={<Login />} />
        <Route path="test" element={<App />} />
        <Route path="dashboard" element={<Dashboard />}>
          <Route index element={<DashboardElement />} />
        </Route>
        <Route path="user" element={<Dashboard />}>
          <Route index element={<UserList />} />
        </Route>
        <Route path="programs" element={<Dashboard />}>
          <Route index element={<Programs />} />
        </Route>
        <Route path="menu" element={<Dashboard />}>
          <Route index element={<Menu />} />
        </Route>
        <Route path="doctors" element={<Dashboard />}>
          <Route index element={<Doctor />} />
        </Route>
        <Route path="appointments" element={<Dashboard />}>
          <Route index element={<Appointment />} />
        </Route>
        <Route path="staff" element={<Dashboard />}>
          <Route index element={<Staff />} />
        </Route>
        <Route path="addstaff" element={<Dashboard />}>
          <Route index element={<AddStaff />} />
        </Route>
        <Route path="addappoint" element={<Dashboard />}>
          <Route index element={<Addappointments />} />
        </Route>
        <Route path="editstaff/:staff_id" element={<Dashboard />}>
          <Route index element={<Editstaff />} />
        </Route>
        <Route path="editappoint/:appoint_id" element={<Dashboard />}>
          <Route index element={<EditAppoint />} />
        </Route>
        <Route path="hospital" element={<Dashboard />}>
          <Route index element={<Hospital />} />
        </Route>
        <Route path="addhospital" element={<Dashboard />}>
          <Route index element={<AddHospitals />} />
        </Route>
        <Route path="edithospital/:hosp_id" element={<Dashboard />}>
          <Route index element={<EditHospitals />} />
        </Route>
        <Route path="livetrack" element={<Dashboard />}>
          <Route index element={<AdminLiveTracking />} />
        </Route>
        <Route path="area" element={<Dashboard />}>
          <Route index element={<PolygonMap />} />
        </Route>
        <Route path="sareas" element={<Dashboard />}>
          <Route index element={<Arealist />} />
        </Route>
        <Route path="clinics" element={<Dashboard />}>
          <Route index element={<Clinics />} />
        </Route>
        <Route path="addclinic" element={<Dashboard />}>
          <Route index element={<AddClinic />} />
        </Route>
        <Route path="editclinic/:clinic_id" element={<Dashboard />}>
          <Route index element={<EditClinic />} />
        </Route>
        <Route path="addregion" element={<Dashboard />}>
          <Route index element={<AddRegion />} />
        </Route>
        <Route path="session-track" element={<Dashboard />}>
          <Route index element={<SessionTrack />} />
        </Route>
        <Route path="session-report" element={<Dashboard />}>
          <Route index element={<SessionReport />} />
        </Route>
        <Route path="doctorbulkassign" element={<Dashboard />}>
          <Route index element={<DoctorBulkAssign />} />
        </Route>
        <Route path="doctorassign" element={<Dashboard />}>
          <Route index element={<DoctorAssignment />} />
        </Route>
        <Route path="billingreport" element={<Dashboard />}>
          <Route index element={<BillingReport />} />
        </Route>
        <Route path="appointment-report" element={<Dashboard />}>
          <Route index element={<AppointmentReport />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);


reportWebVitals();
